import { render } from "./NavigationDrawerTabs.vue?vue&type=template&id=6ff67d0e"
import script from "./NavigationDrawerTabs.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__